"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _card = _interopRequireDefault(require("antd/lib/card"));

var _react = _interopRequireWildcard(require("react"));

var _NotesTable = _interopRequireDefault(require("../../../../components/note/NotesTable"));

require("./participant.scss");

var _button = _interopRequireDefault(require("antd/lib/button"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var _input = _interopRequireDefault(require("antd/lib/input"));

var _pageHeader = _interopRequireDefault(require("antd/lib/page-header"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  inAddMode: false,
  addedNote: {}
};

class ParticipantNoteCard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleSubmit = () => {
      if (this.form.current) {
        this.form.current.validateFields().then(() => {
          this.state.addedNote.participantId = this.props.participant.id;
          this.props.saveClickHandler(this.state.addedNote);
          this.setState({
            inAddMode: false
          });
        });
      }
    };

    this.handleAddClick = () => {
      this.setState({
        inAddMode: true
      });
    };

    this.handleCancelClick = () => {
      this.setState({
        inAddMode: false
      });
    };
  }

  render() {
    const {
      participant,
      notes
    } = this.props;
    const {
      addedNote
    } = this.state;
    const {
      Panel
    } = _collapse.default;

    const genExtra = () => /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "small",
      onClick: this.handleAddClick
    }, "Add Note");

    return /*#__PURE__*/_react.default.createElement("div", {
      id: "participant-notes-container"
    }, this.state.inAddMode ? /*#__PURE__*/_react.default.createElement(_card.default, {
      key: "add"
    }, /*#__PURE__*/_react.default.createElement(_pageHeader.default, {
      title: "Add Note"
    }), /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      layout: "inline",
      key: participant.id,
      onFinish: this.handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "body",
      style: {
        alignItems: 'flex-start',
        marginLeft: '20px'
      },
      rules: [{
        required: true,
        message: 'Note is required!'
      }],
      initialValue: ""
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      onChange: v => {
        addedNote.body = v.target.value;
      },
      style: {
        width: '750px'
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      htmlType: "submit"
    }, "Save")), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.handleCancelClick
    }, "Cancel")))) : /*#__PURE__*/_react.default.createElement(_collapse.default, {
      expandIconPosition: "left"
    }, /*#__PURE__*/_react.default.createElement(Panel, {
      key: "1",
      header: `Notes (${notes ? notes.length : 0})`,
      extra: genExtra()
    }, /*#__PURE__*/_react.default.createElement(_NotesTable.default, {
      notes: notes
    }))));
  }

}

var _default = ParticipantNoteCard;
exports.default = _default;